import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Flex, Switch, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useConfig } from "../../../../_shared";
import { OpenService } from "../../../../types/config";

const { Text } = Typography;

export const CreateTicketFromScheduleOption = observer(() => {
  const t = useTranslation();
  const { message } = useFeedback();
  const config = useConfig<string>(
    OpenService.ConfigKeys.createTicketOnSchedule
  );

  async function saveConfig(value: boolean) {
    if (await config.saveConfig(value.toString())) {
      message.success(t("maintenance:global.messages.save.success"));
    }
  }

  return (
    <Flex vertical gap={12} align="flex-start" justify="start">
      <Text>
        {t("maintenance:administration.general.createticketonschedule.label")}
      </Text>
      <Switch
        checkedChildren={t("maintenance:global.switch.on")}
        unCheckedChildren={t("maintenance:global.switch.off")}
        checked={config.value ? /true/.test(config.value) : false}
        onChange={saveConfig}
      />
    </Flex>
  );
});
